import React from "react";

import styles from "./Label.module.scss";

export default function Label({ htmlFor, required, children, className }) {
  return (
    <div className={`${styles["label-container"]} ${className}`}>
      <label htmlFor={htmlFor}>
        {children}
        {required && (
          <span className={styles["label-container--required"]}>*</span>
        )}
      </label>
    </div>
  );
}
